import { formatPrice, getPrice } from 'utilities/content/content-utilities';
import { DeliveryAndReturnContentItem } from 'types/Product';

const getTwoPersonHtml = (
  site: string | undefined,
  deliveryPrices: { type: string; value: number }[],
): DeliveryAndReturnContentItem => {
  const fallbackPricesVery: Record<string, number> = {
    STD: 8.99,
    EXP: 16.99,
    NXT: 21.99,
  };

  const fallbackPricesVeryIreland: Record<string, number> = {
    STD: 30,
  };

  const content: DeliveryAndReturnContentItem = {
    pageText: '',
    pageLink: '',
    modalHeading: '',
    modalBody: '',
  };

  if (site === 'very') {
    content.pageText = 'Delivery and returns';
    content.pageLink = 'More info';
    content.modalHeading = 'Delivery and Returns';
    content.modalBody = `
      <h3><strong>Delivery of large and bulky items</strong></h3>
      <p>Where available, you can book your delivery date when placing your order. If a confirmed date isn't available for certain items, our delivery partner will contact you to arrange a suitable delivery date.</p>
      <h4><strong>Home Delivery</strong></h4>
      <ul>
        <li>Standard Delivery: ${formatPrice(site, getPrice('STD', fallbackPricesVery, deliveryPrices))} - Expected delivery within 3 days to 3 weeks.</li>
        <li>Express Delivery*: ${formatPrice(site, getPrice('EXP', fallbackPricesVery, deliveryPrices))} - Expected delivery within 2 working days.</li>
        <li>Next Day Delivery*: ${formatPrice(site, getPrice('NXT', fallbackPricesVery, deliveryPrices))} - Expected delivery the next working day.</li>
      </ul>
      <p>Delivery dates and charges will be calculated at checkout based on your order time and selection.</p>
      <p>All deliveries are made Monday to Saturday, between 7am and 7pm, excluding bank holidays.</p>
      <p>*Available for selected items.</p>
      <p>Free delivery promotions only apply to qualifying items. Delivery charges will apply to additional items that don't qualify.</p>
      <br>
      <h3><strong>Returns</strong></h3>
      <p>Returns of large and bulky items are free under our 28 day approval guarantee.</p>
      <p>You can arrange a return by home collection through My Account, you will then be contacted within 3 days to choose an agreed collection date to suit you.</p>
    `;

    return content;
  }

  if (site === 'littlewoods') {
    content.pageText = 'FREE Delivery and returns';
    content.pageLink = 'More info';
    content.modalHeading = 'Delivery and Returns';
    content.modalBody = `
      <h3><strong>Delivery of large and bulky items</strong></h3>
      <p>Where available, you can book your delivery date when placing your order. If a confirmed date isn't available for certain items, our delivery partner will contact you to arrange a suitable delivery date.</p>
      <h4><strong>Home Delivery</strong></h4>
      <ul>
        <li>Standard Delivery: ${formatPrice(site, getPrice('STD', fallbackPricesVery, deliveryPrices))} - Expected delivery within 3 days to 3 weeks.</li>
        <li>Express Delivery*: ${formatPrice(site, getPrice('EXP', fallbackPricesVery, deliveryPrices))} - Expected delivery within 2 working days.</li>
        <li>Next Day Delivery*: ${formatPrice(site, getPrice('NXT', fallbackPricesVery, deliveryPrices))} - Expected delivery the next working day.</li>
      </ul>
      <p>Delivery dates and charges will be calculated at checkout based on your order time and selection.</p>
      <p>All deliveries are made Monday to Saturday, between 7am and 7pm, excluding bank holidays.</p>
      <p>*Available for selected items.</p>
      <p>Free delivery promotions only apply to qualifying items. Delivery charges will apply to additional items that don't qualify.</p>
      <br>
      <h3><strong>Returns</strong></h3>
      <p>Returns of large and bulky items are free under our 28 day approval guarantee.</p>
      <p>You can arrange a return by home collection through My Account, you will then be contacted within 3 days to choose an agreed collection date to suit you.</p>
    `;

    return content;
  }

  if (site === 'veryie') {
    content.pageText = `This is a large item. There will be a delivery cost of ${formatPrice(site, getPrice('STD', fallbackPricesVeryIreland, deliveryPrices))}`;

    return content;
  }
  return content;
};

export default getTwoPersonHtml;
